import { validateQueryParams } from '../../utils/api/api-utils';
import { doGetQCXRequest, doPostQCXRequest, doPutQCXRequest } from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, FOLLOW_UP_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchDAImportacaoByFilter(params = []) {
  const validatedParams = validateQueryParams(params);

  if (validatedParams.length === 0) {
    throw new Error('Parâmetros inválidos');
  }

  validatedParams.push({ name: 'servicoProduto', value: 'IMPORTACAO' });

  return doGetQCXRequest([FOLLOW_UP_ENDPOINT, 'pagination/followup-da'], validatedParams);
}

export async function updateFollowUpDataVencimentoDa(id, dataVencimentoDa) {
  return doPutQCXRequest(
    [FOLLOW_UP_ENDPOINT, 'data-vencimento-da', id],
    null,
    [{ name: 'dataVencimentoDa', value: dataVencimentoDa }]
  );
}

export async function fetchBaixaDAMercadoriasByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length === 0) throw new Error('Parâmetros inválidos');

  return doGetQCXRequest([FOLLOW_UP_ENDPOINT, 'pagination/baixa-da', 'mercadorias'], validatedParams);
}

export async function fetchFollowupsDestinoComDi(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length === 0) throw new Error('Parâmetros inválidos');

  return doGetQCXRequest([FOLLOW_UP_ENDPOINT, 'baixa-da', 'followups-destino'], validatedParams);
}

export async function postTransferirItensDa(body) {
  if (!body || !body.followupOrigemId || !body.followupDestinoId || !Array.isArray(body.itens)) {
    throw new Error('Payload inválido');
  }
  return doPutQCXRequest(['diduimp', 'baixa-da', 'processar'], body);
}

export async function updateMercadoriaQtdeBaixaDa(mercadoriaId, quantidade) {
  if (!mercadoriaId && mercadoriaId !== 0) throw new Error('Mercadoria inválida');
  if (quantidade === undefined || quantidade === null) throw new Error('Quantidade inválida');

  return doPutQCXRequest(
    ['mercadoria', 'baixa-da', 'mercadoria', mercadoriaId, 'qtde-a-baixar'],
    null,
    [{ name: 'quantidade', value: String(quantidade) }]
  );
}

export async function fetchEstornoDAMercadoriasByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length === 0) throw new Error('Parâmetros inválidos');

  return doGetQCXRequest([FOLLOW_UP_ENDPOINT, 'pagination/estorno-da', 'mercadorias'], validatedParams);
}

export async function putEstornarItensDa(body) {
  if (!body || !body.followupDestinoId || !Array.isArray(body.mercadoriaIds)) {
    throw new Error('Payload inválido');
  }
  return doPutQCXRequest(['diduimp', 'baixa-da', 'estornar'], body);
}

export async function putEstornarQuantidadeDa(body) {
  if (!body || !body.followupDestinoId || !body.mercadoriaCloneId || body.quantidade === undefined) {
    throw new Error('Payload inválido');
  }
  return doPutQCXRequest(['diduimp', 'baixa-da', 'estornar-quantidade'], body);
}

